import React, { useEffect, useState, useRef } from "react";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import { Route, Link, Routes, useLocation, useNavigate } from 'react-router-dom';
//import './css/index.css';
import { Flex, Layout, Button } from "antd";
import BilliardsScoreboard from './components/BilliardsScoreboard';
const { Header, Footer, Sider, Content } = Layout;

const TLSOverlay = () => {

    const navigate = useNavigate();

    return (
        <Layout>
            <BilliardsScoreboard/>
        </Layout>



    )
}

export default TLSOverlay;